import React, { useEffect } from "react";
import { Tabs, Collapse, Skeleton, Image } from "antd";
import ResponseView from "../Home/ResponseView";
import { useState } from "react";
import useAxios from "../../../hooks/useAxios";
import useGetFile from "../../../hooks/useGetFile";
import useAuthCandidateToken from "../../../hooks/useAuthCandidateToken";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import BASE from "../../../config";
import url from "../../../services/url";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import moment from "moment";
import RenderFiles from "./RenderFiles";
import TinNumber from "./TinNumber";

const { TabPane } = Tabs;
const { Panel } = Collapse;

const ApplicationDetals = ({ data, AGENT_INTERVIEWS }) => {
  const api = useAxios();
  const { candidateToken } = useAuthCandidateToken();
  const { getImage } = useGetFile(candidateToken);
  const [dynamicInterviews, setDynamicInterviews] = useState([]);
  const [isNonAgent, setIsNonAgent] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formList, setFormList] = useState([]);
  const [tinDetails, setTinDetails] = useState([]);
  const [docUrl, setDocUrl] = useState({});

  const { files: allFiles } = data;
  const interviews = data?.interviewDetails?.interviewData || [];

  let files = [];

  if (allFiles.length !== 0) {
    const fileData = [];
    for (let file of allFiles) {
      if (file.fieldname) {
        if (file.fieldname.toLowerCase().indexOf("resume") !== -1) {
          fileData.push({
            key: "Resume",
            file,
          });
        }
        if (file.fieldname.toLowerCase().indexOf("video") !== -1) {
          fileData.push({
            key: "Video",
            file,
          });
        }
        if (file.fieldname.toLowerCase().indexOf("profile photo") !== -1) {
          fileData.push({
            key: "Photo",
            file,
          });
        }
      }
    }
    files = fileData;
  }

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const promise = [getCandidateFormsList()];

      const isVersant = interviews?.find((ele) => ele?.type === "versant");

      if (isVersant || data?.trf?.candidateType === "Non-Agent") {
        promise.push(getBindTin());
      }

      if (data?.trf?.candidateType === "Non-Agent") {
        promise.push(getDynamicInterviews(data?.trf));
      }
      await Promise.all(promise);
      setLoading(false);
    };
    init();
  }, [data]);

  const getBindTin = async () => {
    try {
      const { data: result } = await api.get(
        `/manageTin/candidateTinList/${data?._id}`,
        {
          tokenType: "candidate",
        },
      );

      if (result.success) {
        const filteredTin =
          result.tinDetails?.filter((tin) => tin?.tinStatus) || [];
        setTinDetails(filteredTin);
      }
    } catch (err) {
      console.error(err);
      console.log(err?.response?.data?.message);
    }
  };

  const getDynamicInterviews = async (trf) => {
    try {
      const dynamicInterviews = await api.get(
        `/competencyInterviewSetUp/competencyAllInterview/designationId/${trf?.designationId}/departmentId/${trf?.departmentId}/candidate/${data?._id}`,
        // `/competencyInterviewsetup/designationId/${trf?.designationId}`,
        {
          tokenType: "candidate",
        },
      );
      const dynamic = dynamicInterviews.data?.sort(
        (a, b) => a?.interviewNo - b?.interviewNo,
      );

      const _isNonAgent = trf?.candidateType === "Non-Agent" ? true : false;
      setDynamicInterviews(dynamic);
      setIsNonAgent(_isNonAgent);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getCandidateFormsList = async () => {
    const result = await api.get(`/candidateDocuments/candidate/${data?._id}`, {
      tokenType: "candidate",
    });
    setFormList(result.data.candidateDocumentDetails);
  };

  const selectedForRound = interviews.reduce((acc, item) => {
    if (item.finished) {
      acc++;
    }
    return acc;
  }, 0);

  const noFilesFound = !formList.some((ele) => ele.length !== 0);

  const lastArrangeInterview = dynamicInterviews.find(
    (ele) =>
      ele?._id ===
      interviews[interviews.length - 1]?.designationInterviewsNamesMappingId,
  );

  return (
    <Tabs
      className="w-100 custom-tabs"
      defaultActiveKey="1"
      onChange={(activeKey) => {
        console.log(activeKey);
      }}
      tabBarStyle={{
        color: "black",
        borderBottom: "2px solid grey",
        width: "100%",
      }}
    >
      <TabPane className="w-100" tab="Status" key="1">
        <div className="accordion-collapse collapse show">
          <div className="accordion-body card-custom">
            {loading ? (
              <ul className="list-group list-group-flush">
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
              </ul>
            ) : (
              <>
                {isNonAgent ? (
                  <ul className="list-group list-group-flush">
                    <div className="container text-center status-cont p-3">
                      <p className="m-0 fs-5 fw-bold">
                        <strong>
                          Selected for Round {selectedForRound} of{" "}
                          {dynamicInterviews?.length}
                        </strong>
                      </p>
                      {interviews.length !== 0 && (
                        <p className="m-0">
                          {
                            lastArrangeInterview?.interviewDetails
                              ?.interviewNames
                          }{" "}
                          on{" "}
                          {moment(
                            interviews[interviews.length - 1]?.start,
                          ).format("MMMM D, YYYY - h:mm A")}
                        </p>
                      )}
                    </div>

                    {dynamicInterviews?.map((interview) => {
                      const Founded = interviews?.find(
                        (ele) =>
                          interview?._id ===
                          ele?.designationInterviewsNamesMappingId,
                      );
                      return (
                        <li className="list-group-item flex justify-between flex-col gap-1">
                          <div className="flex w-full items-center">
                            <div className="flex-1">
                              <p className="fs-5 m-0">
                                Round {interview?.interviewNo}:{" "}
                                {interview?.interviewDetails?.interviewNames}
                              </p>
                              {Founded ? (
                                <>
                                  <p className="m-0">
                                    {moment(Founded?.start).format(
                                      "MMMM D, YYYY - h:mm A",
                                    )}
                                  </p>
                                  {Founded?.finished &&
                                  Founded?.status === "Selected" ? (
                                    <p className="text-success mb-0">
                                      Successfully completed this round
                                    </p>
                                  ) : Founded?.status === "Rejected" ? (
                                    <p className="m-0 text-danger">Rejected</p>
                                  ) : (
                                    <p className="m-0 text-warning">
                                      Scheduled
                                    </p>
                                  )}
                                </>
                              ) : (
                                <>
                                  {/* <p className="m-0 text-muted">
                                      After completed the Round{" "}
                                      {interview?.interviewNo - 1}
                                    </p> */}
                                </>
                              )}
                            </div>
                            {Founded && (
                              <div>
                                <img
                                  src={
                                    Founded?.finished
                                      ? "/img/completed.svg"
                                      : "/img/pending.svg"
                                  }
                                  height="26"
                                  alt=""
                                />
                              </div>
                            )}
                          </div>
                          {interview?.interviewDetails?.interviewNames ===
                            "Versant Round" && (
                            <>
                              {tinDetails?.map((ele) => {
                                console.log(ele);
                                if (ele?.tinStatus) {
                                  return (
                                    <TinNumber key={ele?._id} data={ele} />
                                  );
                                }
                              })}
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <ul className="list-group list-group-flush">
                    <div className="container text-center status-cont p-3">
                      <p className="m-0 fs-5 fw-bold">
                        <strong>
                          Selected for Round {selectedForRound} of {5}
                        </strong>
                      </p>
                      {interviews.length !== 0 && (
                        <p className="m-0">
                          {
                            AGENT_INTERVIEWS?.find(
                              (item) =>
                                item?.key ===
                                interviews[interviews.length - 1]?.type,
                            )?.label
                          }{" "}
                          on{" "}
                          {moment(
                            interviews[interviews.length - 1]?.start,
                          ).format("MMMM D, YYYY - h:mm A")}
                        </p>
                      )}
                    </div>
                    {AGENT_INTERVIEWS?.map((interview, index) => {
                      const Founded = interviews?.find(
                        (item) => item?.type === interview?.key,
                      );

                      return (
                        <li className="list-group-item flex justify-between flex-col gap-1">
                          <div className="flex justify-between items-center">
                            <div>
                              <p className="fs-5 m-0">
                                Round {index + 1}: {interview?.label}
                              </p>
                              {Founded ? (
                                <>
                                  <p className="m-0">
                                    {moment(Founded?.start).format(
                                      "MMMM D, YYYY - h:mm A",
                                    )}
                                  </p>
                                  {Founded?.finished &&
                                  Founded?.status === "Selected" ? (
                                    <p className="text-success mb-0">
                                      Successfully completed this round
                                    </p>
                                  ) : Founded?.status === "Rejected" ? (
                                    <p className="m-0 text-danger">Rejected</p>
                                  ) : (
                                    <p className="m-0 text-warning">
                                      Scheduled
                                    </p>
                                  )}
                                </>
                              ) : (
                                <>
                                  {/* <p className="m-0 text-muted">
                                    After completed the Round {index}
                                  </p> */}
                                </>
                              )}
                            </div>
                            {Founded && (
                              <div>
                                <img
                                  src={
                                    Founded?.finished
                                      ? "/img/completed.svg"
                                      : "/img/pending.svg"
                                  }
                                  height="26"
                                  alt=""
                                />
                              </div>
                            )}
                          </div>
                          {interview?.key === "versant" && (
                            <>
                              {tinDetails?.map((ele) => {
                                if (ele?.tinStatus) {
                                  return (
                                    <TinNumber key={ele?._id} data={ele} />
                                  );
                                }
                              })}
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </>
            )}
          </div>
        </div>
      </TabPane>
      <TabPane className="w-100" tab="Application Details" key="2">
        <div className="accordion-collapse collapse show">
          <div className="accordion-body card-custom">
            {loading ? (
              <ul className="list-group list-group-flush">
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
              </ul>
            ) : (
              <ResponseView responses={data?.responses} />
            )}
          </div>
        </div>
      </TabPane>
      <TabPane className="w-100" tab="Attachment" key="3">
        <div className="accordion-collapse collapse show">
          <div className="accordion-body card-custom">
            {loading ? (
              <ul className="list-group list-group-flush">
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
                <li className="d-flex justify-content-between align-items-center mb-2">
                  <Skeleton.Input active={true} size={"default"} block={true} />
                </li>
              </ul>
            ) : (
              <div className="p-3">
                {files?.length == 0 &&
                data?.aadharCardImage?.length == 0 &&
                data?.panCardImage?.length == 0 &&
                noFilesFound ? (
                  <> No files found</>
                ) : (
                  <>
                    {files?.map((file_, index) => {
                      console.log(file_);
                      const ext = file_?.file?.path
                        ?.split(".")
                        .pop()
                        ?.toLowerCase();
                      return (
                        <Collapse
                          onChange={async (e) => {
                            if (e.length === 0) {
                              return;
                            }
                            let keyPath = e[0];
                            if (!docUrl?.[keyPath]) {
                              const url = await getImage(file_?.file?.path);
                              setDocUrl({
                                ...docUrl,
                                [keyPath]: url,
                              });
                            }
                          }}
                          ghost
                        >
                          <Panel
                            key={`file_${index}`}
                            header={
                              <div>
                                {" "}
                                <div className="d-flex align-items-center justify-content-between overflow-hidden">
                                  <div className="resume ">
                                    <i
                                      className="fa fa-paperclip mr-2"
                                      aria-hidden="true"
                                    ></i>
                                    <span>
                                      {" "}
                                      {data?.name}@{file_?.key}.{ext}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            }
                          >
                            <header className="App-header">
                              <div
                                style={{ height: "auto", overflowY: "auto" }}
                              >
                                <RenderFiles
                                  src={docUrl?.[`file_${index}`]}
                                  ext={ext}
                                  width={"30vw"}
                                />
                              </div>
                            </header>
                          </Panel>
                        </Collapse>
                      );
                    })}
                    {data?.candidatePhoto?.length !== 0 && (
                      <Collapse
                        ghost
                        onChange={async (e) => {
                          if (e.length === 0) {
                            return;
                          }

                          if (data?.documentType === "S3" && BASE.storageType) {
                            let keyPath = e[0];
                            if (!docUrl?.[keyPath]) {
                              const file = await getImage(
                                data?.candidatePhoto[0].path,
                              );
                              setDocUrl({
                                ...docUrl,
                                [keyPath]: file,
                              });
                            }
                          }
                        }}
                      >
                        <Panel
                          key={"photo"}
                          header={
                            <div>
                              {" "}
                              <div className="d-flex align-items-center justify-content-between overflow-hidden">
                                <div className="resume ">
                                  <i
                                    className="fa fa-paperclip mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  <span> {data?.name}@ Photo</span>
                                </div>
                              </div>
                            </div>
                          }
                        >
                          {data?.candidatePhoto && (
                            <RenderFiles
                              ext={"png"}
                              src={docUrl?.photo}
                              width={"30vw"}
                            />
                          )}
                        </Panel>
                      </Collapse>
                    )}
                    {data?.candidateSignature?.length !== 0 && (
                      <Collapse
                        ghost
                        onChange={async (e) => {
                          if (e.length === 0) {
                            return;
                          }
                          if (data?.documentType === "S3" && BASE.storageType) {
                            let keyPath = e[0];
                            if (!docUrl?.[keyPath]) {
                              const file = await getImage(
                                data?.candidateSignature[0].path,
                              );
                              setDocUrl({
                                ...docUrl,
                                [keyPath]: file,
                              });
                            }
                          }
                        }}
                      >
                        <Panel
                          key={"signature"}
                          header={
                            <div>
                              {" "}
                              <div className="d-flex align-items-center justify-content-between overflow-hidden">
                                <div className="resume ">
                                  <i
                                    className="fa fa-paperclip mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  <span> {data?.name}@ Signature</span>
                                </div>
                              </div>
                            </div>
                          }
                        >
                          {data?.candidateSignature && (
                            <RenderFiles
                              ext={"png"}
                              src={docUrl?.signature}
                              width={"30vw"}
                            />
                          )}
                        </Panel>
                      </Collapse>
                    )}
                    {data?.aadharCardImage?.length !== 0 && (
                      <Collapse
                        ghost
                        onChange={async (e) => {
                          if (e.length === 0) {
                            return;
                          }
                          if (data?.documentType === "S3" && BASE.storageType) {
                            let keyPath = e[0];
                            if (!docUrl?.[keyPath]) {
                              const file = await getImage(
                                data?.aadharCardImage[0].path,
                              );
                              setDocUrl({
                                ...docUrl,
                                [keyPath]: file,
                              });
                            }
                          }
                        }}
                      >
                        <Panel
                          key={"aadhar_card"}
                          header={
                            <div>
                              {" "}
                              <div className="d-flex align-items-center justify-content-between overflow-hidden">
                                <div className="resume ">
                                  <i
                                    className="fa fa-paperclip mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  <span> {data?.name}@ Aadhar Card</span>
                                </div>
                              </div>
                            </div>
                          }
                        >
                          {data?.aadharCardImage && (
                            <RenderFiles
                              ext={"png"}
                              src={docUrl?.aadhar_card}
                              width={"30vw"}
                            />
                          )}
                        </Panel>
                      </Collapse>
                    )}
                    {data?.panCardImage?.length !== 0 && (
                      <Collapse
                        ghost
                        onChange={async (e) => {
                          if (e.length === 0) {
                            return;
                          }
                          if (data?.documentType === "S3" && BASE.storageType) {
                            let keyPath = e[0];
                            if (!docUrl?.[keyPath]) {
                              const file = await getImage(
                                data?.panCardImage[0].path,
                              );
                              setDocUrl({
                                ...docUrl,
                                [keyPath]: file,
                              });
                            }
                          }
                        }}
                      >
                        <Panel
                          key={"pan_card"}
                          header={
                            <div>
                              {" "}
                              <div className="d-flex align-items-center justify-content-between overflow-hidden">
                                <div className="resume ">
                                  <i
                                    className="fa fa-paperclip mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  <span> {data?.name}@ PAN Card</span>
                                </div>
                              </div>
                            </div>
                          }
                        >
                          {data?.panCardImage && (
                            <RenderFiles
                              src={docUrl?.pan_card}
                              ext={"png"}
                              width={"30vw"}
                            />
                          )}
                        </Panel>
                      </Collapse>
                    )}
                    {formList?.length !== 0 && (
                      <>
                        {formList?.map((ele) => {
                          return ele?.files?.map((form, index) => {
                            const ext = form.filename
                              .split(".")
                              .pop()
                              ?.toLowerCase();
                            return (
                              <Collapse
                                ghost
                                onChange={async (e) => {
                                  if (e.length === 0) {
                                    return;
                                  }
                                  if (
                                    data?.documentType === "S3" &&
                                    BASE.storageType
                                  ) {
                                    let keyPath = e[0];
                                    if (!docUrl?.[keyPath]) {
                                      const file = await getImage(form.path);
                                      setDocUrl({
                                        ...docUrl,
                                        [keyPath]: file,
                                      });
                                    }
                                  }
                                }}
                              >
                                <Panel
                                  key={`form_${form?._id}`}
                                  header={
                                    <div>
                                      {" "}
                                      <div className="d-flex align-items-center justify-content-between overflow-hidden">
                                        <div className="resume ">
                                          <i
                                            className="fa fa-paperclip mr-2"
                                            aria-hidden="true"
                                          ></i>
                                          <span>
                                            {" "}
                                            {data?.name}@{form.fieldname}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                >
                                  <header className="App-header">
                                    <RenderFiles
                                      src={docUrl?.[`form_${form?._id}`]}
                                      ext={ext}
                                      width={"30vw"}
                                    />
                                  </header>
                                </Panel>
                              </Collapse>
                            );
                          });
                        })}
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </TabPane>
    </Tabs>
  );
};

export default ApplicationDetals;
